<script>
    import {Link} from "svelte-routing";
    import {store} from '../stores.js';
    import {list, page} from '../config.js';
    import storage from '../storage.js';

    const user = store('credential', 'getAuth');
    const dark_mode = store('dark_mode', null, 0);

    // on load
    document.body.classList.toggle('dark-mode-active', $dark_mode);

    const handlerDarkMode = () => {
        dark_mode.save($dark_mode ? 0 : 1);
        document.body.classList.toggle('dark-mode-active', $dark_mode);
    };

    const logout = () => {
        user.remove();
        storage.clear();
        location.href = '/';
    };

    const popstate = () => {
        document.querySelector('[data-bs-target="#sidebarPanel"]').click();
    };
</script>

<!-- App OffCanvas -->
<div class="offcanvas offcanvas-start" tabindex="-1" id="sidebarPanel">
    <div class="offcanvas-header">
        <h5 id="offcanvas-title" style="font-size: 1.25rem; margin: 0;">Навигация</h5>
        <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
    </div>

    <div class="offcanvas-body mt-1">
        <ul class="listview flush transparent no-line image-listview">


            {#if $user && ($user.tip.toLowerCase().includes('администратор') || $user.tip.toLowerCase().includes('менеджер'))}
                <li>
                    <Link to="/list/16" class="item" on:click={popstate}>
                        <div class="icon-box bg-primary">
                            <i class="fas fa-list"></i>
                        </div>
                        <div class="in">Мои заявки</div>
                    </Link>
                </li>
            {/if}


            {#each list as item}
                {#if $user.id > 0}
                    {#if
                        (
                            $user && $user.calcs && $user.calcs.includes(item.calc)
                        ) && (
                            typeof item.hide === 'undefined' ||
                            item.hide === false
                        )
                    }
                        <li>
                            <Link to="/calc/{ item.link }" class="item" on:click={popstate}>
                                <div class="icon-box bg-primary">
                                    <i class="fas fa-calculator"></i>
                                </div>
                                <div class="in">{ item.title }</div>
                            </Link>
                        </li>
                    {/if}
                {/if}
            {/each}

            {#each page as item}
                {#if $user.id > 0}
                    {#if typeof item.hide === 'undefined' || item.hide === false}
                        <li>
                            <Link to="/{ item.link }" class="item" on:click={popstate}>
                                <div class="icon-box bg-primary">
                                    <i class="fas fa-puzzle-piece"></i>
                                </div>
                                <div class="in">{ item.title }</div>
                            </Link>
                        </li>
                    {/if}
                {/if}
            {/each}
        </ul>
    </div>

    <!-- offcanvas buttons -->
    <div class="sidebar-buttons">
        <Link to="/" class="button" on:click={popstate} on:click={logout}>
            <i class="fas fa-sign-out-alt"></i>
        </Link>
    </div>
    <!-- * offcanvas buttons -->
</div>
<!-- * App OffCanvas -->
